export const SHORTCUTS = {
  introduction: 'i',
  projectSummary: 'p',
  team: 't',
  bmc: 'b',
  testing: 'tg',
  desirabilitySection: 'd',
  customerSegment: 'cs',
  valueProposition: 'vp',
  competitorAnalysis: 'ca',
  customerRelationships: 'cr',
  channels: 'ch',
  feasibility: 'fe',
  keyActivities: 'ka',
  viability: 'v',
  finance: 'f',
  sustainability: 'st',
  contactUs: 'c',
};

export const PORTFOLIO_SHORTCUTS = [
  {
    name: SHORTCUTS.introduction,
  },
  {
    name: SHORTCUTS.projectSummary,
  },
  {
    name: SHORTCUTS.team,
  },
  {
    name: SHORTCUTS.bmc,
  },
  {
    name: SHORTCUTS.testing,
  },
  {
    name: SHORTCUTS.desirabilitySection,
  },
  {
    name: SHORTCUTS.customerSegment,
  },
  {
    name: SHORTCUTS.valueProposition,
  },
  {
    name: SHORTCUTS.competitorAnalysis,
  },
  {
    name: SHORTCUTS.customerRelationships,
  },
  {
    name: SHORTCUTS.channels,
  },
  {
    name: SHORTCUTS.feasibility,
  },
  {
    name: SHORTCUTS.keyActivities,
  },
  {
    name: SHORTCUTS.viability,
  },
  {
    name: SHORTCUTS.finance,
  },
  {
    name: SHORTCUTS.sustainability,
  },
  {
    name: SHORTCUTS.contactUs,
  },
];
